import { CORDOVA_READY, CORDOVA_SET_DEVICE_INFO, CORDOVA_SET_VERSION } from './types';

export default {
  [CORDOVA_READY]: (state) => {
    state.cordovaStatus = 'ready';
  },
  [CORDOVA_SET_VERSION]: (state, version) => {
    state.cordovaVersion = version;
  },
  [CORDOVA_SET_DEVICE_INFO]: (state, device) => {
    state.device = device || state.device;
  },
};



// WEBPACK FOOTER //
// ./src/apps/cordova/store/mutations.js